<template>
  <div id="grid-usuario">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado" color="success" @click="newUser()">Agregar</v-btn>
          </v-card-actions>
          <v-data-table :headers="headers" :items="usuarios" :rows-per-page-items="rowsPerPageItems"
            class="elevation-1">
            <template v-slot:items="props">
              <td>{{ props.item.username }}</td>
              <td class="text-xs-left">{{ props.item.rut }}</td>
              <td class="text-xs-left">
                {{ props.item.nombre }} {{ props.item.apellido }}
              </td>
              <td class="text-xs-left">{{ props.item.estado }}</td>
              <td class="text-xs-left">{{ props.item.fechaUltimoAcceso }}</td>
              <td >
                <v-btn depressed outline icon fab dark color="green darken-4" small title="Ver usuario"
                  @click="viewUser(props.item.username)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado"  depressed outline icon fab dark color="primary" small
                  title="Editar usuario" @click="editUser(props.item.username)">
                  <v-icon>open_in_new</v-icon>
                </v-btn>
                
                <v-btn v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado"  depressed outline icon fab dark color="red darken-4" small
                  title="Eliminar usuario" @click="openDeleteDialog(props.item.id)">
                  <v-icon>clear</v-icon>
                </v-btn>
              </td>
              <td v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado" >
                <v-btn depressed outline icon fab dark color="green darken-4" @click="abrirDialogoAsignar(props.item.id, props.item.nombre, props.item.apellido)"  title="Reasignar usuario" small>
        <v-icon>list_alt</v-icon>
      </v-btn></td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA USUARIO -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn class="btn-sigas" depressed outline icon fab dark color="green darken-4" small>
              <v-icon>remove_red_eye</v-icon> </v-btn><span >&nbsp;Ver usuario</span>
            <v-btn   v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado"  class="btn-sigas" depressed outline icon fab dark color="primary" small>
              <v-icon>open_in_new</v-icon> </v-btn><span v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado" >&nbsp;Editar usuario</span>
              <v-btn v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado"  color="primary" class="btn-sigas"  title="Reasignar usuario" small>
        <v-icon>list_alt</v-icon>
      </v-btn><span v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado" >&nbsp;Reasignar usuario</span>
            
              <v-btn v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado"  class="btn-sigas" depressed outline icon fab dark color="red darken-4"
              small>
              <v-icon>clear</v-icon> </v-btn><span v-if=" getCodigoPerfil() == 'ADM' &&  !contratoExpirado" >&nbsp;Eliminar usuario</span>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <!-- Diálogo de asignación de contratos -->
      <!-- Modal de asignación de contratos -->
<v-dialog v-model="dialogoAsignar" max-width="70vw">
  <v-card>
    <v-card-title class="headline">
      Asignar contratos a {{ nombreUsuario }}
    </v-card-title>
    <v-card-text>
      <!-- Indicador de carga mientras se obtienen contratos -->
      <v-progress-linear
        v-if="cargandoContratos"
        indeterminate
        color="primary"
      ></v-progress-linear>

      <!-- DataTable para listar los contratos disponibles -->
      <div v-else>
        <v-data-table
          :headers="headersContratos"
          :items="contratosOrdenados"
          class="elevation-1"
          hide-default-footer
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox
                v-model="contratosSeleccionados"
                :value="props.item.id"
                hide-details
              ></v-checkbox>
            </td>
            <td class="text-xs-left">{{ props.item.codigo }}</td>
            <td class="text-xs-left">{{ props.item.descripcion }}</td>
            <td class="text-xs-left">{{ props.item.periodo }}</td>
            <td class="text-xs-left">{{ props.item.proceso }}</td>
            <td class="text-xs-left">{{ props.item.fechaFin }}</td>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="dialogoAsignar = false">Cancelar</v-btn>
      <v-btn color="primary" @click="guardarAsignacion">Guardar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

      <!-- dialogo de eliminacion (dar de baja)    -->
      <v-dialog v-model="dialogUser" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Esta seguro?</v-card-title>
          <v-card-text>Esta seguro que desea realizar esta accion.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialogUser = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click="deleteUser()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogo -->
      <!-- dialogo de reset password (correo de reset pass)    -->
      <v-dialog v-model="dialogPass" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Esta seguro?</v-card-title>
          <v-card-text>Esta seguro que desea realizar esta accion.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialogPass = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click="resetPassword()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogo -->
      <v-dialog v-model="dialogEnviando" persistent max-width="390">
        <v-card height="200" style="padding-top: 50px !important"><loading-enviando></loading-enviando></v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import LoadingEnviando from "@/views/ui/Loading.vue";
import jwtDecode from "jwt-decode";
export default {
  name: "grid-usuario",
  components: {
    LoadingEnviando,
  },
  props: {
    tipoUsuario: "",
    tipeView: "",
    fechaFin: String,
  },
  data() {
    return {
      headersContratos: [
      { text: "", value: "selection", sortable: false },
      { text: "Código", value: "codigo", sortable: false },
      { text: "Descripción", value: "descripcion", sortable: false },
      { text: "Periodo", value: "periodo", sortable: false },
      { text: "Proceso", value: "proceso", sortable: false },
      { text: "Fecha Fin", value: "fechaFin", sortable: false }
    ],
      nombreUsuario: "",
      contratosDisponibles: [],  // Todos los contratos disponibles para asignar
      contratosSeleccionados: [],// IDs de contratos seleccionados en el diálogo
      usuarioSeleccionado: null, // Usuario actual al que se le asignan contratos
      dialogoAsignar: false,     // Controla la visibilidad del diálogo
      cargandoContratos: false,   // Indica si los datos de contratos están cargando
      usuarios: [],  
      idUserLogged: "",
      tipoUsuarioL:"",
      loading: false,
      userToDelete: "",
      userToReset: "",
      usuarios: [],
      dialogUser: false,
      dialogPass: false,
      dialogEnviando: false,
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        { text: "Usuario", align: "left", sortable: false, value: "usuario" },
        { text: "RUT", align: "left", sortable: false, value: "rut" },
        { text: "Nombre", sortable: false, value: "nombre" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Ultimo acceso", sortable: false, value: "fechaAcceso" },
        { text: "Accion", sortable: false, value: "" },
      ],
      id: Number,
      editedIndex: -1,
      contratoId: "",
    };
  },
  created() {
  // Inicializar contratoId desde el store o localStorage
  this.contratoId = this.$store.getters.contratoStored;
  if (this.contratoId == null) {
    const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
    if (contratoCerradoConId != null) {
      this.contratoId = contratoCerradoConId.id;
    }
  }

  // Decodificar token y asignar idUserLogged
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const user = decoded.dto;
  this.idUserLogged = user.id;
  this.tipoUsuarioL = user.tipo;
  console.log("this.contratoId" + this.contratoId);

  // Cargar datos de usuarios
  this.loadDataUsuarios();
}
,
  computed: {
    contratoExpirado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      console.log("st::contratoCerradoConId:" + JSON.stringify(contratoCerradoConId, null, 2));
      console.log("this.contratoId" + this.contratoId);
      // if (!this.fechaFin) return false;
      const hoy = new Date();
      const finContrato = new Date(this.fechaFin);
      return finContrato < hoy; // true si la fecha ya pasó
    },
    contratosOrdenados() {
    const hoy = new Date();
    return this.contratosDisponibles
      .filter(contrato => {
        if (!contrato.fechaFin) return false;
        const fechaFinDate = this.parseFechaDDMMYYYY(contrato.fechaFin);
        return fechaFinDate >= hoy;
      })
      .sort((a, b) => {
        const aSelected = this.contratosSeleccionados.includes(a.id);
        const bSelected = this.contratosSeleccionados.includes(b.id);
        if (aSelected && !bSelected) return -1;
        if (!aSelected && bSelected) return 1;
        return 0;
      });
  },
  },
  methods: {
    parseFechaDDMMYYYY(fechaStr) {
    if (!fechaStr) return null;
    // "28-11-2025" -> ["28", "11", "2025"]
    const [day, month, year] = fechaStr.split("-");
    // new Date(año, mesIndex, día), donde mesIndex va de 0 a 11
    return new Date(year, month - 1, day);
  },
    async abrirDialogoAsignar(usuario, nombre, apellido) {
  this.usuarioSeleccionado = usuario;
  this.nombreUsuario = nombre + " "+ apellido; // Para mostrar en el título
  this.dialogoAsignar = true;
  this.cargandoContratos = true;
  try {
    // Cargar contratos relacionados al usuario logueado
    let response =null;
    if(this.tipoUsuarioL == 'ADMINISTRADOR'){
    response =   await axios
        .get("/contratos/userlogged/")
        .then(function (response) {
          console.log("response.data:: ", response.data)
          return response;
        })
        .catch(function (error) {
          console.log(error);
        });
    }else{
      const body = { userId: this.idUserLogged };
      response = await axios.post("/contratos/usuarios/filter", body);
    }
    // Mapear la respuesta incluyendo id, codigo, descripción, periodo, proceso y fechaFin
    this.contratosDisponibles = response.data.map(p => ({
      id: p.id,
      codigo: p.codigo,
      descripcion: p.descripcion || "",
      periodo: p.periodo,
      proceso: p.proceso,
      fechaFin: p.fechaFin
    }));
    console.log("Contratos disponibles:", this.contratosDisponibles);
    console.log("IDs de contratos disponibles:", this.contratosDisponibles.map(item => item.id));
     
    // Si necesitas cargar contratos asignados previamente, puedes hacerlo aquí.
    const bodyU = { userId: usuario };
    const respAsignados = await axios.post("/contratos/usuarios/filter", bodyU);
    this.contratosSeleccionados = respAsignados.data.map(c =>
       typeof c === "object" ? c.id : c
     );
     console.log("IDs de contratos asignados:", this.contratosSeleccionados);
  } catch (error) {
    console.error("Error cargando contratos:", error);
  } finally {
    this.cargandoContratos = false;
  }
}
,
    // Envía la selección de contratos a la API para actualizar la relación usuario_contrato
async guardarAsignacion() {
  if (!this.usuarioSeleccionado) return;
  this.cargandoContratos = true;
  try {
    // Se envía el arreglo de IDs directamente.
    await axios.put(`/user/contratos/actualizar/${this.usuarioSeleccionado}`, this.contratosSeleccionados);
    // Éxito: actualización realizada; se puede actualizar la lista local si es necesario
    this.dialogoAsignar = false; // Cerrar diálogo
  } catch(error) {
    console.error('Error guardando asignación de contratos:', error);
  } finally {
    this.cargandoContratos = false;
  }
}

  ,
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      console.log("contratoCerradoConId " + contratoCerradoConId);
      console.log("this.contratoId" + this.contratoId);
      if (contratoCerradoConId && contratoCerradoConId.id === this.contratoId) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo
    },
    async loadDataUsuarios() {
      this.usuarios = await this.loadUsersByContract();
    },

    async loadUsersByContract() {
      let that = this;
      return await axios
        .get(
          "/usuariosAsignados/" + this.contratoId + "/tipo/" + this.tipoUsuario
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    newUser() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "UsuarioRegistra",
          params: { tipeView: "crear", tipeUser: this.tipoUsuario },
        });
      }, 1000);
    },
    viewUser(u) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "UsuarioRegistra",
          params: { username: u, tipeView: "consulta" },
        });
      }, 1000);
    },
    editUser(id) {
      this.$router.push({
        name: "UsuarioRegistra",
        params: { username: id, tipeView: "modifica" },
      });
    },
    openDeleteDialog(user) {
      this.userToDelete = user;
      this.dialogUser = true;
    },
    openResetDialog(user) {
      this.userToReset = user;
      this.dialogPass = true;
    },
    async deleteUser() {
      await this.delete();

      this.reloadGrid();
    },
    async delete() {
      // let idUserLogged = this.$store.getters.userLogged.id;
      return await axios
        .delete(
          "/user/" +
          this.userToDelete +
          "/contrato/" +
          this.idUserLogged +
          "/" +
          this.contratoId
        )
        .then(function (response) {
          response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reloadGrid() {
      this.dialog = false;
      if (this.tipoUsuario == "AGENCIA") {
        this.$parent.$parent.reloadAgenciaUser();
      }
      if (this.tipoUsuario == "PROVEEDOR") {
        this.$parent.$parent.reloadProveedorUser();
      }
    },

    async resetPassword() {
      this.dialogPass = false;
      this.dialogEnviando = true;
      var respuesta = await this.envioCorreo();
      this.dialogEnviando = false;
      if (respuesta) {
        window.getApp.$emit("APP_RESET_PASSWORD_OK");
      } else {
        window.getApp.$emit("APP_RESET_PASSWORD_GRID");
      }
    },
    async envioCorreo() {
      this.body = {
        username: this.userToReset,
      };

      return await axios
        .post("/public/user/forgot-password", this.body)
        .then((response) => {
          this.resp = response.data;
          // console.log("aaa:" + response.data);
          if (response.data) {
            return true;
          } else {
            return false;
          }
        })
        .catch(function (error) {
          console.log(error);
          return false;
        });
    },
  },
};
</script>
